import {styled} from '@material-ui/core/styles'
import {Backdrop} from '@material-ui/core'

const GlobalOverlay = styled(Backdrop)({
  cursor: 'pointer',
  zIndex: 1250,
})

export default GlobalOverlay
